import * as FilePond from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';

function setupPond(el) {
    FilePond.create(el, {
        storeAsFile: true,
        imageResizeTargetWidth: 1024,
        // imageTransformVariants: {
        //     thumb_: (transforms) => {
        //         transforms.resize = {
        //             size: {
        //                 width: 384,
        //                 height: 384,
        //             },
        //         };
        //         return transforms;
        //     },
        // },
    });
}

export default function () {
    FilePond.registerPlugin(
        FilePondPluginImagePreview,
        FilePondPluginFileValidateSize,
        FilePondPluginImageEdit,
        FilePondPluginImageTransform,
        FilePondPluginImageCrop,
        FilePondPluginImageResize,
    );
    document.querySelectorAll('[data-pond]').forEach(setupPond);
}